import React, { useEffect, useMemo } from "react";
import { Col, Row } from "reactstrap";
import { CustomLabel } from "../../../utilities/utll";
import { Button, Input, Select, DatePicker, message } from "antd";
import FileUploadDragger from "../../../common/dragUpload";
import { ReloadOutlined, SaveOutlined } from "@ant-design/icons";
import { useState } from "react";
import { useIrnStore } from "../../../store/useIrnstore";
import { useCallback } from "react";
import {
  getStoresByUserId,
  getIRNTransactionByStore,
  getPoDetail,
  createIRN,
  uploadDocApi,
} from "../../../services/irn";
import dayjs from "dayjs";
import InvoiceTable from "./invoiceTable";
import { useAutoSelectStore } from "../../../store/useStoreSelect";

export const InwardForm = () => {
  const [formData, setFormData] = useState({
    storeCode: null,
    storeName: null,
    // irnNo: "",
    receivedFrom: null,
    poNo: "",
    poDate: "",
    poExpiryDate: "",
    supplierCode: "",
    supplierName: "",
    poQty: "",
    remainingPoQty: "",
    poValue: "",
    noOfInvoice: 1,
    remainingPoValue: "",
    type: null,
    deliveryPersonName: "",
    vehicleNo: "",
    courierAgenecyName: "",
    noOfBoxes: "",
    boxWeight: "",
    invoiceDetails: [{ invoiceNo: "", invoiceQty: 0, invoiceValue: 0 }],
    podDocument: null,
    receiverPic: null,
    irnQty: 0,
    irnValue: 0,
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [stores, setStores] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const receivedFromOptions = ["Supplier", "Warehouse"];
  const typeOptions = ["Transporter", "Private Vehicle", "Courier Agency"];
  const [poTollrance, setPoTollrance] = useState(0);

  useEffect(() => {
    const initializeData = async () => {
      try {
        setLoading(true);
        await fetchStores();
      } catch (error) {
        console.error("Error initializing form data:", error);
        message.error("Failed to load user information.");
      } finally {
        setLoading(false);
      }
    };

    initializeData();
  }, []);

  const fetchStores = async () => {
    try {
      const response = await getStoresByUserId();
      if (response && response.Data) {
        setStores(response.Data);
      }
    } catch (error) {
      console.error("Error fetching stores:", error);
      message.error("Failed to load stores.");
    }
  };

  // const fetchTransactions = async (storeCode) => {
  //   try {
  //     setLoading(true);
  //     const response = await getIRNTransactionByStore(storeCode);
  //     if (response && response.Data && response.Data.length > 0) {
  //       setTransactions(response.Data);

  //       if (response.Data.length === 1) {
  //         const singleTransaction = response.Data[0];
  //         const transactionValue =
  //           singleTransaction.Transactiono ||
  //           singleTransaction.TransactionNo ||
  //           singleTransaction.TransNo;
  //         setFormData((prev) => ({
  //           ...prev,
  //           // irnNo: transactionValue,
  //           invoiceDetails: prev.invoiceDetails.map((inv) => ({
  //             ...inv,
  //             // irnNo: transactionValue,
  //           })),
  //         }));
  //       }
  //     } else {
  //       setTransactions([]);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching transactions:", error);
  //     setTransactions([]);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const fetchPoDetails = async () => {
    if (!formData.poNo || !formData.receivedFrom || !formData.storeCode) {
      return;
    }

    try {
      setLoading(true);
      const response = await getPoDetail(
        formData.receivedFrom,
        formData.poNo,
        formData.storeCode,
      );
      if (!response?.IsSuccess) {
        resetPoDetails();
        message.error(response?.DisplayMessage);
        return;
      }
      if (!response?.Data || response.Data.length === 0) {
        resetPoDetails();
        message.info(response?.DisplayMessage);
        return;
      }
      if (response && response.Data && response.Data.length > 0) {
        const poData = response.Data[0];
        setPoTollrance(poData?.PORemainQtyWithTollrance);
        setFormData((prev) => ({
          ...prev,
          poDate: poData.PurchaseOrderDate || prev.poDate,
          poExpiryDate: poData.PoExpiryDate || prev.poExpiryDate,
          supplierCode: poData.Supplier || prev.supplierCode,
          supplierName: poData.SupplierName || prev.supplierName,
          poQty: poData.PurchaseOrderTotalQuantity?.toString() || prev.poQty,
          poValue: poData.PurchaseOrderTotalValue?.toString() || prev.poValue,
          remainingPoValue:
            poData.PORemainingValue?.toString() || prev.remainingPoValue,
          remainingPoQty:
            poData?.PORemainingQty?.toString() || prev?.remainingPoQty,
        }));
        message.success(response?.DisplayMessage);
      } else {
        message.info(response?.DisplayMessage);
      }
    } catch (error) {
      console.error("Error fetching PO details:", error);
      message.error("Failed to load PO details. Please check the PO number.");
    } finally {
      setLoading(false);
    }
  };
  const resetPoDetails = () => {
    setPoTollrance(0);
    setFormData((prev) => ({
      ...prev,
      poDate: "",
      poExpiryDate: "",
      supplierCode: "",
      supplierName: "",
      poQty: "",
      poValue: "",
      remainingPoValue: "",
      remainingPoQty: "",
    }));
  };

  const handleInputChange = useCallback(
    (field, value) => {
      if (field === "vehicleNo") {
        const regex = /^[A-Za-z0-9]*$/; // allow only letters + numbers, NO space

        if (!regex.test(value)) {
          return; // ❌ block invalid characters
        }
      }
      if (field === "noOfBoxes") {
        // Only digits allowed (0–9)
        const regex = /^[0-9]*$/;

        if (!regex.test(value)) {
          return; // ❌ block invalid input
        }
      }
      if (field === "boxWeight") {
        const regex = /^\d*\.?\d{0,3}$/;

        // Block invalid input
        if (!regex.test(value)) {
          return;
        }
      }
      if (field === "receivedFrom") {
        setFormData((prev) => ({
          ...prev,
          poNo: "",
          poDate: "",
          poExpiryDate: "",
          supplierCode: "",
          supplierName: "",
          poQty: "",
          poValue: "",
          remainingPoValue: "",
          remainingPoQty: "",
        }));
      }
      setFormData((prev) => ({
        ...prev,
        [field]: value,
      }));

      if (errors[field]) {
        setErrors((prev) => ({
          ...prev,
          [field]: "",
        }));
      }
    },
    [errors],
  );
  const handleFileUpload = async (info, percent, type) => {
    let uploadedFile = info;

    if (uploadedFile instanceof File) {
      const sanitizedName = uploadedFile.name.replace(/\s+/g, "");

      uploadedFile = new File([uploadedFile], sanitizedName, {
        type: uploadedFile.type,
        lastModified: uploadedFile.lastModified,
      });
    }
    try {
      const res = await uploadDocApi(uploadedFile, percent);

      if (res) {
        setFormData((prev) => ({
          ...prev,
          [type]: res, // podDocument OR receiverPic
        }));
      }
    } catch (error) {
      console.error("File upload failed", error);
      message.error("File upload failed. Please try again.");
    }
  };
  useAutoSelectStore({
    stores,
    onChange: ({ storeCode, storeName }) => {
      handleInputChange("storeCode", storeCode);
      handleInputChange("storeName", storeName);
    },
  });

  const validateForm = () => {
    const required = (val) =>
      val !== undefined && val !== null && String(val).trim() !== "";

    const newErrors = {};

    // ---------- SIMPLE FIELD VALIDATIONS ----------
    const fieldRules = {
      storeName: "Please Select Store Name",
      receivedFrom: "Please Enter Received From",
      type: "Please Select Type",
      poNo: "Please Enter PO No",
      podDocument: "Please upload POD Document",
      receiverPic: "Please upload Receiver Document",
      noOfBoxes: "Please Select Number Of Box",
    };
    if (formData.type === "Transporter") {
      fieldRules.vehicleNo = "Please Enter Vehicle No";
    }

    Object.entries(fieldRules).forEach(([field, errMsg]) => {
      if (!required(formData[field])) newErrors[field] = errMsg;
    });

    // ---------- INVOICE VALIDATION ----------
    const invoiceErrors = formData.invoiceDetails.map((inv) => {
      const row = {};

      if (!required(inv.invoiceNo)) row.invoiceNo = "Invoice No is Required";
      if (!required(inv.invoiceQty) || Number(inv.invoiceQty) <= 0)
        row.invoiceQty = "Invoice Qty must be greater than 0";
      if (!required(inv.invoiceValue) || Number(inv.invoiceValue) < 0)
        row.invoiceValue = "Invoice Value must be greater than 0";

      return Object.keys(row).length ? row : null;
    });

    if (invoiceErrors.some((err) => err)) {
      newErrors.invoiceDetails = invoiceErrors;
    }

    // ---------- DISPLAY ERRORS ----------
    if (Object.keys(newErrors).length > 0) {
      Object.entries(newErrors).forEach(([field, value]) => {
        if (Array.isArray(value)) {
          value.forEach((err, index) => {
            if (err) {
              Object.values(err).forEach((msg) => {
                message.error(`Invoice ${index + 1}: ${msg}`);
              });
            }
          });
        } else {
          message.error(value);
        }
      });
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // ----------------------------------------
  // HANDLE SUBMIT
  // ----------------------------------------
  const handleSubmit = async () => {
    if (!validateForm()) return;

    try {
      setLoading(true);

      const response = await createIRN(formData);

      message.success(
        response?.DisplayMessage ||
          response?.Message ||
          "IRN created successfully!",
      );

      handleReset();
    } catch (error) {
      console.error("Error submitting form:", error);
      message.error(
        error?.message || "Failed to create IRN. Please try again.",
      );
    } finally {
      setLoading(false);
    }
  };

  const getDayjsDate = (date) => {
    return date ? dayjs(date) : null;
  };

  const handleReset = () => {
    setPoTollrance(0);
    setFormData({
      storeCode: null,
      storeName: null,
      // irnNo: "",
      receivedFrom: null,
      poNo: "",
      poDate: "",
      poExpiryDate: "",
      supplierCode: "",
      supplierName: "",
      poQty: "",
      poValue: "",
      remainingPoValue: "",
      remainingPoQty: "",
      irnQty: 0,
      irnValue: 0,
      noOfInvoice: 1,
      type: null,
      deliveryPersonName: "",
      vehicleNo: "",
      courierAgenecyName: "",
      noOfBoxes: "",
      boxWeight: "",
      invoiceDetails: [{ invoiceNo: "", invoiceQty: "", invoiceValue: "" }],
      podDocument: null,
      receiverPic: null,
    });
    setTransactions([]);
    setErrors({});
  };

  const removeFile = (type) => {
    setFormData((prev) => ({
      ...prev,
      [type]: null, // podDocument OR receiverPic
    }));
  };

  const removeInvoice = (index) => {
    setFormData((prev) => ({
      ...prev,
      invoiceDetails: prev.invoiceDetails.filter((_, i) => i !== index),
    }));
  };

  const updateInvoice = (index, field, value) => {
    // const numericValue = Number(value);
    const numericValue = parseFloat(value || "0");
    // -------- QTY VALIDATION --------
    if (field === "invoiceQty") {
      // const regex = /^[0-9]*$/;
      const regex = /^\d*(\.\d{0,3})?$/;
      if (!regex.test(value) || numericValue < 0) return;

      const otherQtyTotal = formData.invoiceDetails
        .filter((_, i) => i !== index)
        .reduce((sum, inv) => sum + Number(inv.invoiceQty || 0), 0);

      const newTotalQty = otherQtyTotal + numericValue;

      if (newTotalQty > poTollrance) {
        message.error(
          "Invoice quantity exceeds remaining PO Tollarance quantity",
        );
        return; // ❌ block update
      }
    }
    // Validation only for invoiceValue
    if (field === "invoiceValue") {
      const regex = /^\d*(\.\d*)?$/;
      if (!regex.test(value)) return;
      if (numericValue < 0) {
        message.error("Invoice value cannot be negative");
        return;
      }
      // const otherRowsTotal = formData.invoiceDetails
      //   .filter((_, i) => i !== index)
      //   .reduce((sum, inv) => sum + Number(inv.invoiceValue || 0), 0);
      // const newTotal = otherRowsTotal + numericValue;
      // if (
      //   numericValue > formData?.remainingPoValue ||
      //   newTotal > formData?.remainingPoValue
      // ) {
      //   message.error("Invoice value exceeds remaining PO value");
      //   return; // ❌ Block updating the state
      // }
    }
    setFormData((prev) => ({
      ...prev,
      invoiceDetails: prev.invoiceDetails.map((invoice, i) =>
        i === index ? { ...invoice, [field]: value } : invoice,
      ),
    }));
  };

  const addInvoice = () => {
    const last = formData.invoiceDetails[formData.invoiceDetails.length - 1];
    if (
      !last.invoiceNo?.trim() ||
      !last.invoiceDate ||
      !last.invoiceQty ||
      !last.invoiceValue ||
      Number(last.invoiceQty) == 0 ||
      last.invoiceValue == 0
    ) {
      message.error("Please fill all deatils of invoice.");
      return;
    }
    const cleaned = last.invoiceNo.trim().toLowerCase();
    const isDuplicate = formData?.invoiceDetails
      .slice(0, -1)
      .some((inv) => inv.invoiceNo.trim().toLowerCase() === cleaned);
    if (isDuplicate) {
      return message.error("Invoice No must be unique");
    }
    // if (
    //   !formData?.remainingPoValue ||
    //   totalValue >= formData.remainingPoValue
    // ) {
    //   return message.error(
    //     "Invoice value exceeds remaining PO value or remaining PO value is zero"
    //   );
    // }
    if (!poTollrance || totalQty >= poTollrance) {
      return message.error(
        "Invoice qty exceeds remaining PO qty Tollarance or remaining PO Qty is zero",
      );
    }

    setFormData((prev) => ({
      ...prev,
      invoiceDetails: [
        ...prev.invoiceDetails,
        {
          // irnNo: formData?.irnNo,
          invoiceNo: "",
          invoiceDate: "",
          invoiceQty: "",
          invoiceValue: "",
        },
      ],
      noOfInvoice: prev.noOfInvoice + 1,
    }));
  };

  const totalValue = useMemo(() => {
    const value = formData?.invoiceDetails?.reduce(
      (sum, item) => sum + Number(item.invoiceValue || 0),
      0,
    );
    // setFormData((prev) => ({ ...prev, irnValue: value }));
    return value;
  }, [formData?.invoiceDetails]);

  const totalQty = useMemo(() => {
    const qty = formData?.invoiceDetails?.reduce(
      (sum, item) => sum + Number(item.invoiceQty || 0),
      0,
    );
    // setFormData((prev) => ({
    //   ...prev,
    //   irnQty: qty,
    // }));
    return qty;
  }, [formData?.invoiceDetails]);

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      irnValue: Number(totalValue || 0),
      irnQty: Number(totalQty || 0),
    }));
  }, [totalValue, totalQty]);

  const onBlurCheckDuplicateInvoice = (index) => {
    const currentInvoiceNo = formData.invoiceDetails[index].invoiceNo
      .trim()
      .toLowerCase();
    if (!currentInvoiceNo) return;

    const isDuplicate = formData.invoiceDetails.some(
      (inv, i) =>
        i !== index && inv.invoiceNo.trim().toLowerCase() === currentInvoiceNo,
    );

    if (isDuplicate) {
      message.error("Invoice No must be unique");
      setFormData((prev) => ({
        ...prev,
        invoiceDetails: prev.invoiceDetails.map((invoice, i) =>
          i === index ? { ...invoice, invoiceNo: "" } : invoice,
        ),
      }));
    }
  };

  return (
    // <Form layout="vertical" form={form}>
    <>
      <Row justify="center">
        <Col
          xl={{ size: 3, offset: 9 }}
          md={{ size: 6 }}
          sm={{ size: 12 }}
          xs={{ size: 12 }}
          style={{ textAlign: "center" }}
        >
          <Button
            type="primary"
            icon={<SaveOutlined />}
            size="large"
            style={{
              marginRight: "0.75rem",
              backgroundColor: "#52c41a", // elegant green
              borderColor: "#52c41a",
              boxShadow: "0 2px 6px rgba(82, 196, 26, 0.3)",
            }}
            onClick={handleSubmit}
          >
            Submit
          </Button>

          <Button
            icon={<ReloadOutlined />}
            size="large"
            style={{
              borderColor: "#ff1818ff",
              color: "#ff1818ff",
            }}
            onClick={handleReset}
          >
            Reset
          </Button>
        </Col>
      </Row>
      <Row>
        <Col xl={3} md={6}>
          <CustomLabel children={"Store Name"} isImportnt={true} />
          <Select
            placeholder="Select Store Name"
            allowClear
            options={stores.map((s) => ({
              label: s.Combined,
              value: s.StoreCode,
            }))}
            value={formData?.storeCode}
            showSearch
            optionFilterProp="label"
            size="medium"
            style={{ width: "100%" }}
            onChange={(val) => {
              const selected = stores.find((s) => s.StoreCode === val);
              handleInputChange("storeCode", val);
              handleInputChange("storeName", selected?.Combined || "");
              // fetchTransactions(val);
            }}
          />
        </Col>
        {/* <Col xl={3} lg={3} md={6} sm={12}>
          <CustomLabel children={"Transaction No"} isImportnt={true} />

          <Input
            type="text"
            placeholder="Enter Transaction No"
            size="medium"
            value={formData.irnNo}
            disabled={true}
          />
        </Col> */}
        <Col xl={3} md={6}>
          <CustomLabel children={"Received From"} isImportnt={true} />
          <Select
            placeholder="Select Received From"
            allowClear
            showSearch
            optionFilterProp="label"
            size="medium"
            style={{ width: "100%" }}
            options={receivedFromOptions.map((o) => ({ label: o, value: o }))}
            value={formData.receivedFrom}
            onChange={(val) => handleInputChange("receivedFrom", val)}
          />
        </Col>
        <Col xl={3} lg={3} md={6} sm={12}>
          <CustomLabel
            //  children={"PO No"}
            children={
              !formData.receivedFrom || formData.receivedFrom === "Supplier"
                ? "PO No"
                : "BOL_No"
            }
            isImportnt={true}
          />
          <Input
            type="text"
            placeholder="Enter PO No"
            size="medium"
            value={formData.poNo}
            onChange={(e) => handleInputChange("poNo", e.target.value)}
            onBlur={fetchPoDetails}
            disabled={!formData?.receivedFrom}
          />
        </Col>
      </Row>
      <Row>
        <Col xl={3} md={6}>
          <CustomLabel
            children={
              !formData.receivedFrom || formData.receivedFrom === "Supplier"
                ? "PO Date"
                : "To Date"
            }
            isImportnt={false}
          />
          <DatePicker
            format="DD-MMM-YYYY"
            placeholder="Select a date"
            style={{ width: "100%" }}
            value={formData.poDate ? getDayjsDate(formData.poDate) : null}
            disabled
          />
        </Col>
        <Col xl={3} md={6}>
          <CustomLabel
            children={
              !formData.receivedFrom || formData.receivedFrom === "Supplier"
                ? "PO Expiry Date"
                : "To Expiry Date"
            }
            isImportnt={false}
          />
          <DatePicker
            format="DD-MMM-YYYY"
            placeholder="Select a date"
            style={{ width: "100%" }}
            value={
              formData.poExpiryDate ? getDayjsDate(formData.poExpiryDate) : null
            }
            disabled
          />
        </Col>
        <Col xl={3} lg={3} md={6} sm={12}>
          <CustomLabel
            children={
              !formData.receivedFrom || formData.receivedFrom === "Supplier"
                ? "Supplier Code"
                : "Warehouse Code"
            }
            isImportnt={true}
          />
          <Input
            type="text"
            placeholder="Enter Supplier Code"
            size="medium"
            value={formData.supplierCode}
            disabled
          />
        </Col>
        <Col xl={3} lg={3} md={6} sm={12}>
          <CustomLabel
            children={
              !formData.receivedFrom || formData.receivedFrom === "Supplier"
                ? "Supplier Name"
                : "Warehouse Name"
            }
            isImportnt={true}
          />
          <Input
            type="text"
            placeholder="Enter Supplier Name"
            size="medium"
            value={formData.supplierName}
            disabled
          />
        </Col>
      </Row>
      <Row>
        <Col xl={3} lg={3} md={6} sm={12}>
          <CustomLabel
            children={
              !formData.receivedFrom || formData.receivedFrom === "Supplier"
                ? "Po QTY"
                : "To QTY"
            }
            isImportnt={true}
          />
          <Input
            type="text"
            placeholder="Enter PO QTY"
            size="medium"
            value={formData.poQty}
            disabled
          />
        </Col>
        <Col xl={3} lg={3} md={6} sm={12}>
          <CustomLabel
            children={
              !formData.receivedFrom || formData.receivedFrom === "Supplier"
                ? "Remaining Po QTY"
                : "Remaining To QTY"
            }
            isImportnt={true}
          />
          <Input
            type="text"
            placeholder="Enter Remaning PO QTY"
            size="medium"
            value={formData.remainingPoQty}
            disabled
          />
        </Col>
        <Col xl={3} lg={3} md={6} sm={12}>
          <CustomLabel
            children={
              !formData.receivedFrom || formData.receivedFrom === "Supplier"
                ? "Po Value"
                : "To Value"
            }
            isImportnt={true}
          />
          <Input
            type="text"
            placeholder="Enter PO Value"
            size="medium"
            value={formData.poValue}
            disabled
          />
        </Col>
        <Col xl={3} lg={3} md={6} sm={12}>
          <CustomLabel
            children={
              !formData.receivedFrom || formData.receivedFrom === "Supplier"
                ? "Remaining PO Value"
                : "Remaining TO Value"
            }
            isImportnt={true}
          />
          <Input
            type="text"
            placeholder="Enter Remaining PO Value"
            size="medium"
            value={formData.remainingPoValue}
            disabled
          />
        </Col>
        <Col xl={3} md={6}>
          <CustomLabel children={"Type"} isImportnt={true} />
          <Select
            id="roletype"
            placeholder="Select Type"
            allowClear
            showSearch
            optionFilterProp="label"
            size="medium"
            style={{ width: "100%" }}
            options={typeOptions.map((t) => ({ label: t, value: t }))}
            value={formData.type}
            onChange={(val) => handleInputChange("type", val)}
          />
        </Col>

        <Col xl={3} lg={3} md={6} sm={12}>
          <CustomLabel children={"Delivery Person Name"} isImportnt={true} />
          <Input
            type="text"
            placeholder="Enter Delivery Person Name"
            size="medium"
            value={formData.deliveryPersonName}
            onChange={(e) =>
              handleInputChange("deliveryPersonName", e.target.value)
            }
            disabled={!formData.type}
          />
        </Col>
        <Col xl={3} lg={3} md={6} sm={12}>
          <CustomLabel
            children={"Vehicle No"}
            isImportnt={formData.type === "Transporter" ? true : false}
          />
          <Input
            type="text"
            placeholder="Enter Vehicle No"
            size="medium"
            value={formData.vehicleNo}
            onChange={(e) => {
              let value = e.target.value.toUpperCase();

              // Allow only A-Z, 0-9 and space
              if (/^[A-Z0-9 ]*$/.test(value)) {
                handleInputChange("vehicleNo", value);
              }
            }}
            // onChange={(e) => handleInputChange("vehicleNo", e.target.value)}
          />
        </Col>
        <Col xl={3} lg={3} md={6} sm={12}>
          <CustomLabel children={"Courier Agency Name"} isImportnt={true} />
          <Input
            type="text"
            placeholder="Enter Courier Agency Name"
            size="medium"
            value={formData.courierAgenecyName}
            onChange={(e) =>
              handleInputChange("courierAgenecyName", e.target.value)
            }
            disabled={!(formData.type === "Courier Agency")}
          />
        </Col>
        <Col xl={3} lg={3} md={6} sm={12}>
          <CustomLabel children={"Number Of Box"} isImportnt={true} />
          <Input
            type="text"
            placeholder="Enter Number Of Box"
            size="medium"
            value={formData.noOfBoxes}
            onChange={(e) => handleInputChange("noOfBoxes", e.target.value)}
          />
        </Col>
        <Col xl={3} md={6}>
          <CustomLabel children="Weight (KG)" />
          <Input
            placeholder="Enter Weight"
            value={formData.boxWeight}
            onChange={(e) => handleInputChange("boxWeight", e.target.value)}
          />
        </Col>
      </Row>
      <Row style={{ marginBottom: "50px" }}>
        <Col xl={3} lg={3}>
          <CustomLabel children={"POD(Proof of Delivery)"} isImportnt={true} />
          <FileUploadDragger
            value={formData.podDocument}
            onChange={(info, percent, type) =>
              handleFileUpload(info, percent, "podDocument")
            }
            onRemove={() => removeFile("podDocument")}
            type="podDocument"
          />
        </Col>
        <Col xl={3} lg={3}>
          <CustomLabel children={"Reciever Pic"} isImportnt={true} />
          <FileUploadDragger
            value={formData.receiverPic}
            onChange={(info, percent, type) =>
              handleFileUpload(info, percent, "receiverPic")
            }
            onRemove={() => removeFile("receiverPic")}
            type="receiverPic"
          />
        </Col>
        <Col xl={6} lg={6}>
          <InvoiceTable
            updateInvoice={updateInvoice}
            removeInvoice={removeInvoice}
            formData={formData}
            addInvoice={(total) => addInvoice(total)}
            totalValue={totalValue}
            totalQty={totalQty}
            onBlurCheckDuplicateInvoice={onBlurCheckDuplicateInvoice}
          />
        </Col>
      </Row>
    </>
  );
};
